import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import Header from "@components/MainNavigation/Header/Header";
import { AppBarStyled } from "@components/MainNavigation/Header/Header.styles";
import NavigationMenu from "@components/MainNavigation/NavigationMenu/NavigationMenu";
import Sidebar from "@components/MainNavigation/Sidebar/Sidebar";
import { LayoutContainerStyled, MainStyled } from "@layouts/DashboardLayout.styles";
import { Outlet } from "react-router-dom";

const DashboardLayout: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <LayoutContainerStyled>
      <AppBarStyled position="fixed" className="px-24">
        <Header />
        <NavigationMenu openSidebar={setOpen} />
      </AppBarStyled>
      <Sidebar open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} />

      <MainStyled open={open} isMobile={isMobile} className="pt-80">
        <Outlet />
      </MainStyled>
    </LayoutContainerStyled>
  );
};

export default DashboardLayout;
